import styled from 'styled-components'

import { color, media, radius, spacing, typography } from '../../themes'

export const Container = styled.button`
  cursor: pointer;
  color: ${color('white')};
  background: #06c755;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: ${radius('sm')};
  padding: 0;
  height: 56px;
  padding-right: 56px;

  ${media.tablet} {
    max-width: 270px;
    padding-right: 0;
  }

  & > svg {
    min-width: 56px;
    width: 56px;
    height: 56px;
    padding: ${spacing(2)};
  }
`

export const Text = styled.span`
  ${typography('button1')}
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
